module.exports = __webpack_public_path__ + "img/imgBath.da0942e5.jpg";